import { render, staticRenderFns } from "./SberPaymentBlockIcons.vue?vue&type=template&id=6018f9bb&"
import script from "./SberPaymentBlockIcons.vue?vue&type=script&lang=js&"
export * from "./SberPaymentBlockIcons.vue?vue&type=script&lang=js&"
import style0 from "./SberPaymentBlockIcons.vue?vue&type=style&index=0&lang=postcss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports